import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { fetchNewsList } from '../../services/newsService';
import { NewsItem } from '../../types';
import NewsCard from './NewsCard';

const NewsFeed: React.FC = () => {
    const [news, setNews] = useState<NewsItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [tag, setTag] = useState<string | null>(null);

    useEffect(() => { fetchNewsList().then(d => { setNews(d); setLoading(false); }); }, []);

    const allTags = Array.from(new Set(news.flatMap(n => n.tags))).sort();
    const filtered = tag ? news.filter(n => n.tags.includes(tag)) : news;

    return (
        <Box sx={{ py: { xs: 4, md: 8 } }}>
            <Container maxWidth="lg">
                <Box sx={{ mb: 6 }}>
                    <Typography variant="h2" sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, mb: 1 }}>News & Articles</Typography>
                    <Typography variant="body1" color="text.secondary">Thoughts on Java, distributed systems, and engineering</Typography>
                </Box>
                <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mb: 4 }}>
                    <Chip label="All" onClick={() => setTag(null)} color={tag === null ? 'primary' : 'default'} variant={tag === null ? 'filled' : 'outlined'} sx={{ fontWeight: 600 }} />
                    {allTags.map(t => (
                        <Chip key={t} label={t} onClick={() => setTag(t === tag ? null : t)} color={tag === t ? 'primary' : 'default'} variant={tag === t ? 'filled' : 'outlined'} sx={{ fontWeight: 500 }} />
                    ))}
                </Stack>
                {loading && <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>}
                {!loading && (
                    <Grid container spacing={3}>
                        {filtered.map(item => <Grid item xs={12} sm={6} md={4} key={item.id}><NewsCard news={item} /></Grid>)}
                    </Grid>
                )}
                {!loading && filtered.length === 0 && <Box sx={{ textAlign: 'center', py: 8 }}><Typography variant="h6" color="text.secondary">No articles found.</Typography></Box>}
            </Container>
        </Box>
    );
};

export default NewsFeed;
